import axios from 'axios';

const ensureRequestedWithHeader = () => {
	const headers = axios.defaults?.headers as
		| {
				common?: Record<string, string>;
				[key: string]: unknown;
		  }
		| undefined;

	if (!headers) {
		return;
	}

	if (headers.common) {
		headers.common['X-Requested-With'] = 'XMLHttpRequest';
		return;
	}

	headers['X-Requested-With'] = 'XMLHttpRequest';
};

export default async function ensureCsrfCookie(): Promise<void> {
	ensureRequestedWithHeader();
	await axios.get('/sanctum/csrf-cookie');
}
